export default "__VITE_ASSET__Bz94OS24__"